/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} subscriptionDurationChangedParams
* @property {string} action - {intent/confirm}
* @property {GUID} appInstanceId - app id
* @property {number} daysAdded - number of days added to duration
* @property {string} origin - dashboard/editor
* @property {GUID} subscriptionId - subscription Id
**/
/**
 * Name: Subscription duration changed. Evid: 614.
 * Event description: sent when duration is changed for a subscription (e.g. duration extended).

 * action - Type: string. Desc: {intent/confirm}
 *
 * appInstanceId - Type: guid. Desc: app id
 *
 * daysAdded - Type: numeric. Desc: number of days added to duration
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * subscriptionId - Type: guid. Desc: subscription Id
 * @param {subscriptionDurationChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionDurationChanged = function (params) {
    return { evid: 614, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} mySubscriptionsActionItemClickParams
* @property {string} action - name of the action {cancel, buy_new_plan, reactivate},
* @property {GUID} appInstanceId - app id
* @property {boolean} emptyState - indicates if action item was clicked in empty state (no purchased Subscriptions)
* @property {GUID} planGuid - plan guid
* @property {GUID} subscriptionId - subscription id
**/
/**
 * Name: My Subscriptions - action item click. Evid: 605.
 * Event description: sent when action item is clicked in My Subscription page.

 * action - Type: string. Desc: name of the action {cancel, buy_new_plan, reactivate},
 *
 * appInstanceId - Type: guid. Desc: app id
 *
 * emptyState - Type: bool. Desc: indicates if action item was clicked in empty state (no purchased Subscriptions)
 *
 * planGuid - Type: guid. Desc: plan guid
 *
 * subscriptionId - Type: guid. Desc: subscription id
 * @param {mySubscriptionsActionItemClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySubscriptionsActionItemClick = function (params) {
    return { evid: 605, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} subscriptionsToastClickParams
* @property {GUID} appInstanceId - app_id
* @property {string} origin - dashboard/editor
* @property {string} toastValue - what does this toast do?
**/
/**
 * Name: Subscriptions Toast click. Evid: 613.
 * Event description: sent when User clicks on a toast in Subscriptions page.

 * appInstanceId - Type: guid. Desc: app_id
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * toastValue - Type: string. Desc: what does this toast do?
 * @param {subscriptionsToastClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionsToastClick = function (params) {
    return { evid: 613, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} subscriptionListFilterAppliedParams
* @property {GUID} appInstanceId - app id
* @property {string} filter - vertical/status
* @property {string} origin - dashboard/editor
* @property {number} totalSubscriptions - number of subscriptions as appears to the user. From  widget (at OneApp) we can't have the number of subs since it is always up to 3 there
**/
/**
 * Name: Subscription list filter applied. Evid: 610.
 * Event description: sent when list of subscriptions is filtered.

 * appInstanceId - Type: guid. Desc: app id
 *
 * filter - Type: string. Desc: vertical/status
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * totalSubscriptions - Type: numeric. Desc: number of subscriptions as appears to the user. From  widget (at OneApp) we can't have the number of subs since it is always up to 3 there
 * @param {subscriptionListFilterAppliedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionListFilterApplied = function (params) {
    return { evid: 610, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} singleSubscriptionPageLoadedParams
* @property {GUID} appInstanceId - app id
* @property {string} origin - dashboard/editor
* @property {string} paymentStatus - payment status
* @property {GUID} subscriptionId - subscription id
* @property {GUID} viewedMemberUuid - Member viewed
**/
/**
 * Name: Single subscription page loaded. Evid: 602.
 * Event description: sent when an individual purchased subscription detail page is loaded.

 * appInstanceId - Type: guid. Desc: app id
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * paymentStatus - Type: string. Desc: payment status
 *
 * subscriptionId - Type: guid. Desc: subscription id
 *
 * viewedMemberUuid - Type: guid. Desc: Member viewed
 * @param {singleSubscriptionPageLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var singleSubscriptionPageLoaded = function (params) {
    return { evid: 602, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} subscriptionNumberOfSessionsChangedParams
* @property {string} action - {intent/confirm}
* @property {GUID} appInstanceId - app id
* @property {number} newSessions - new number of sessions offered
* @property {string} origin - dashboard/editor
* @property {number} originalSessions - number of sessions originally offered
* @property {GUID} subscriptionId - subscription ID
**/
/**
 * Name: Subscription number of sessions changed. Evid: 612.
 * Event description: sent when number of sessions is edited for a subscription.

 * action - Type: string. Desc: {intent/confirm}
 *
 * appInstanceId - Type: guid. Desc: app id
 *
 * newSessions - Type: numeric. Desc: new number of sessions offered
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * originalSessions - Type: numeric. Desc: number of sessions originally offered
 *
 * subscriptionId - Type: guid. Desc: subscription ID
 * @param {subscriptionNumberOfSessionsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionNumberOfSessionsChanged = function (params) {
    return { evid: 612, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/*event 600 on project 'com.wixpress.subscriptions-bm' has no function name set, please set one in BI Catalog.*/
/**
* @typedef {Object} subscriptionsMiscClickParams
* @property {string} referralInfo - identifier of a button, link
**/
/**
 * Name: Subscriptions Misc Click. Evid: 617.
 * Event description: Buttons/links/etc clicks at random places..

 * referralInfo - Type: string. Desc: identifier of a button, link
 * @param {subscriptionsMiscClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionsMiscClick = function (params) {
    return { evid: 617, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} subscriptionSuspendedOrReactivatedParams
* @property {string} action - 'suspend', 'suspend-confirm', 'reactivate', 'reactivate-confirm'
* @property {GUID} appInstanceId - app id
* @property {string} origin - dashboard/editor
* @property {GUID} subscriptionId - subscription id
**/
/**
 * Name: Subscription suspended or reactivated. Evid: 609.
 * Event description: sent when a subscription is suspended or reactivated.

 * action - Type: string. Desc: 'suspend', 'suspend-confirm', 'reactivate', 'reactivate-confirm'
 *
 * appInstanceId - Type: guid. Desc: app id
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * subscriptionId - Type: guid. Desc: subscription id
 * @param {subscriptionSuspendedOrReactivatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionSuspendedOrReactivated = function (params) {
    return { evid: 609, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} mySubscriptionsOpenedParams
* @property {string} origin -
* @property {string} referralInfo - page/widget/cta which referred to My Subscriptions. E.g. {login-menu, ma-menu}
* @property {string} tabName - on app - indicate which tab is seen{active,expired}
* @property {number} totalSubscriptions - number of subscriptions as appears to the user
**/
/**
 * Name: My Subscriptions - opened. Evid: 616.
 * Event description: sent when My Subscriptions page is opened.

 * origin - Type: string.
 *
 * referralInfo - Type: string. Desc: page/widget/cta which referred to My Subscriptions. E.g. {login-menu, ma-menu}
 *
 * tabName - Type: string. Desc: on app - indicate which tab is seen{active,expired}
 *
 * totalSubscriptions - Type: numeric. Desc: number of subscriptions as appears to the user
 * @param {mySubscriptionsOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySubscriptionsOpened = function (params) {
    return { evid: 616, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} subscriptionMarkedAsPaidParams
* @property {string} action - {intent/confirm}
* @property {GUID} appInstanceId - app id
* @property {string} origin - dashboard/editor
* @property {GUID} subscriptionId - subscription id
**/
/**
 * Name: Subscription marked as paid. Evid: 615.
 * Event description: sent when subscription is marked as paid.

 * action - Type: string. Desc: {intent/confirm}
 *
 * appInstanceId - Type: guid. Desc: app id
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * subscriptionId - Type: guid. Desc: subscription id
 * @param {subscriptionMarkedAsPaidParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionMarkedAsPaid = function (params) {
    return { evid: 615, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} subscriptionInvoicesActionParams
* @property {string} action - preview, ...
* @property {GUID} invoiceId - invoice_id
* @property {GUID} subscriptionId - null
**/
/**
 * Name: Subscription Invoices action. Evid: 618.
 * Event description: Invoices actions at Single Subscription.

 * action - Type: string. Desc: preview, ...
 *
 * invoiceId - Type: guid. Desc: invoice_id
 *
 * subscriptionId - Type: guid.
 * @param {subscriptionInvoicesActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionInvoicesAction = function (params) {
    return { evid: 618, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} manageSubscriptionClickParams
* @property {string} appinstanceid - app id
* @property {string} origin - dashboard/editor
* @property {string} paymentStatus - payment status
* @property {GUID} subscriptionId - subscription id
**/
/**
 * Name: Manage subscription click. Evid: 608.
 * Event description: sent when a User clicks on a manage subscription CTA.

 * appinstanceid - Type: string. Desc: app id
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * paymentStatus - Type: string. Desc: payment status
 *
 * subscriptionId - Type: guid. Desc: subscription id
 * @param {manageSubscriptionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageSubscriptionClick = function (params) {
    return { evid: 608, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} subscriptionCancelledParams
* @property {GUID} appInstanceId - app id
* @property {string} expirationTime - expiration time of a subscription (now/period end)
* @property {string} origin - dashboard/editor
* @property {string} paymentStatus - payment status
* @property {GUID} subscriptionId - subscription id
**/
/**
 * Name: Subscription cancelled. Evid: 604.
 * Event description: sent when subscription cancellation is confirmed.

 * appInstanceId - Type: guid. Desc: app id
 *
 * expirationTime - Type: string. Desc: expiration time of a subscription (now/period end)
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * paymentStatus - Type: string. Desc: payment status
 *
 * subscriptionId - Type: guid. Desc: subscription id
 * @param {subscriptionCancelledParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionCancelled = function (params) {
    return { evid: 604, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} mySubscriptionsCancelSubscriptionConfirmedParams
* @property {string} action - value of the cancel action {cancel} for initiate, {cancel-confirm} for confirmation in modal
* @property {GUID} appId - vertical id (stores, paid plans, invoices)
* @property {GUID} appInstanceId - app id
* @property {GUID} originEntityId - plan_guid, product_id or invoice_id
* @property {GUID} subscriptionId - subscription id
**/
/**
 * Name: My Subscriptions - cancel subscription. Evid: 607.
 * Event description: sent when subscription cancellation is confirmed in Modal.

 * action - Type: string. Desc: value of the cancel action {cancel} for initiate, {cancel-confirm} for confirmation in modal
 *
 * appId - Type: guid. Desc: vertical id (stores, paid plans, invoices)
 *
 * appInstanceId - Type: guid. Desc: app id
 *
 * originEntityId - Type: guid. Desc: plan_guid, product_id or invoice_id
 *
 * subscriptionId - Type: guid. Desc: subscription id
 * @param {mySubscriptionsCancelSubscriptionConfirmedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySubscriptionsCancelSubscriptionConfirmed = function (params) {
    return { evid: 607, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} subscriptionFreeTrialDurationExtendedParams
* @property {GUID} appInstanceId - app id
* @property {number} daysAdded - number of days added
* @property {number} freeTrialDays - number of days the trial was extended for
* @property {string} origin - dashboard/editor
* @property {GUID} subscriptionId - subscription id
**/
/**
 * Name: Subscription duration extended. Evid: 611.
 * Event description: sent when duration is extended for a subscription.

 * appInstanceId - Type: guid. Desc: app id
 *
 * daysAdded - Type: numeric. Desc: number of days added
 *
 * freeTrialDays - Type: numeric. Desc: number of days the trial was extended for
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * subscriptionId - Type: guid. Desc: subscription id
 * @param {subscriptionFreeTrialDurationExtendedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionFreeTrialDurationExtended = function (params) {
    return { evid: 611, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} subscriptionCancelClickParams
* @property {GUID} appInstanceId - app id
* @property {string} origin - dashboard/editor
* @property {string} paymentStatus - payment status
* @property {GUID} subscriptionId - subscription id
**/
/**
 * Name: Subscription cancel click. Evid: 603.
 * Event description: sent when a owner clicks on cancel subscription.

 * appInstanceId - Type: guid. Desc: app id
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * paymentStatus - Type: string. Desc: payment status
 *
 * subscriptionId - Type: guid. Desc: subscription id
 * @param {subscriptionCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var subscriptionCancelClick = function (params) {
    return { evid: 603, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} purchasedSubscriptionsLoadedParams
* @property {number} activeSubscriptions - number of ACTIVE subscriptions as appears to the user
* @property {GUID} appInstanceId - app instance id
* @property {string} origin - dashboard/editor
* @property {string} referralInfo - the place click came from
* @property {number} totalSubscriptions - number of subscriptions as appears to the user
* @property {GUID} viewedMemberUuid - {APP ONLY} number of ACTIVE subscriptions as appears to the user
**/
/**
 * Name: Purchased subscriptions loaded. Evid: 601.
 * Event description: sent when contact purchased subscriptions page loads.

 * activeSubscriptions - Type: numeric. Desc: number of ACTIVE subscriptions as appears to the user
 *
 * appInstanceId - Type: guid. Desc: app instance id
 *
 * origin - Type: string. Desc: dashboard/editor
 *
 * referralInfo - Type: string. Desc: the place click came from
 *
 * totalSubscriptions - Type: numeric. Desc: number of subscriptions as appears to the user
 *
 * viewedMemberUuid - Type: guid. Desc: {APP ONLY} number of ACTIVE subscriptions as appears to the user
 * @param {purchasedSubscriptionsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var purchasedSubscriptionsLoaded = function (params) {
    return { evid: 601, src: 92, endpoint: 'subscriptions-bm', params: params };
};
/**
* @typedef {Object} mySubscriptionsShowDetailsParams
* @property {GUID} appInstanceId - app id
* @property {GUID} planGuid - plan guid
* @property {GUID} subscriptionId - subscription id
* @property {string} subscriptionStatus - status of the subscription at the time of action
**/
/**
 * Name: My Subscriptions - show details. Evid: 606.
 * Event description: sent when Subscription drawer with details is expanded.

 * appInstanceId - Type: guid. Desc: app id
 *
 * planGuid - Type: guid. Desc: plan guid
 *
 * subscriptionId - Type: guid. Desc: subscription id
 *
 * subscriptionStatus - Type: string. Desc: status of the subscription at the time of action
 * @param {mySubscriptionsShowDetailsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySubscriptionsShowDetails = function (params) {
    return { evid: 606, src: 92, endpoint: 'subscriptions-bm', params: params };
};
//# sourceMappingURL=index.js.map